import { useLanguage } from "@/contexts/LanguageContext";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const DifferentiatorSection = () => {
  const { t } = useLanguage();
  const faqs = ["1", "2", "3", "4", "5"];

  return (
    <section className="py-24 bg-paper">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12 max-w-2xl mx-auto">
          <div className="eyebrow mb-4" style={{ color: "#6C4DFF" }}>{t("eyebrow.faq")}</div>
          <h2 className="font-display text-4xl md:text-5xl text-paper-ink mb-4">{t("faq.title")}</h2>
          <p className="text-paper-ink/60">{t("faq.subtitle")}</p>
        </div>
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((id) => (
              <AccordionItem key={id} value={`faq-${id}`} className="bg-paper-light rounded-2xl border border-paper-ink/10 px-6">
                <AccordionTrigger className="text-left font-semibold text-paper-ink hover:no-underline py-5">
                  {t(`faq.q${id}`)}
                </AccordionTrigger>
                <AccordionContent className="text-paper-ink/65 pb-5 leading-relaxed">
                  {t(`faq.a${id}`)}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default DifferentiatorSection;
